module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": !_vm.hasPrevious,
      "type": "button"
    },
    on: {
      "click": _vm.handlePreviousButton
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('button', {
      key: page,
      staticClass: "btn btn-white",
      class: {
        'active': _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          return _vm.handlePageSelection(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasNext
    },
    on: {
      "click": _vm.handleNextButton
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdc6bf22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/Paginator.vue
// module id = 3387
// module chunks = 3